var _rect, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBeside(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5440_74493",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5440_74493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 21L2 16L7 11L8.425 12.4L5.825 15H21V17H5.825L8.425 19.6L7 21ZM17 13L15.575 11.6L18.175 9H3V7H18.175L15.575 4.4L17 3L22 8L17 13Z",
    fill: "#494C4F"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBeside);
export default __webpack_public_path__ + "static/media/icon_beside.93e937fe58455ada9bbc1d94e4e92089.svg";
export { ForwardRef as ReactComponent };